<template>
  <v-card flat width="100%" color="transparent">
  <v-app-bar app fixed >
    <v-toolbar   flat>
      <v-app-bar-nav-icon v-if="$vuetify.breakpoint.mobile" @click="drawer=!drawer"></v-app-bar-nav-icon>

      <v-toolbar-title>Abel Sekwa Sekwala</v-toolbar-title>

      <v-spacer></v-spacer>
        <div v-if="!$vuetify.breakpoint.mobile" class="mt-5">
        <v-tabs >
          <v-tabs-slider color="orange"></v-tabs-slider>

          <v-tab v-for="item in items" :key="item" class="white--text" 
          @click="navigate(item.link)"
          >
            {{ item.title }}
          </v-tab>
        </v-tabs>
      </div>
    </v-toolbar>
  </v-app-bar>

    <v-navigation-drawer v-model="drawer" fixed >
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="text-h6">
            My Portfolio
          </v-list-item-title>
          <v-list-item-subtitle>
            Hi
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list
        dense
        nav
      >
        <v-list-item
          v-for="item in items"
          :key="item.title"
          link
          @click="navigate(item.link)"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </v-card>
</template>
<script>
export default {
  data() {
    return {
      drawer: false,
      items: [
        {
          title: "About",
          icon: "mdi-account", // Replace "mdi-account" with the desired icon for "About"
          link: "#about", // Replace "/about" with the link you want to associate with "About"
        },
        {
          title: "Skills",
          icon: "mdi-cog", // Replace "mdi-cog" with the desired icon for "Skills"
          link: "#skills", // Replace "/skills" with the link you want to associate with "Skills"
        },
        {
          title: "Portfolio",
          icon: "mdi-briefcase", // Replace "mdi-briefcase" with the desired icon for "Portfolio"
          link: "#portfolio", // Replace "/portfolio" with the link you want to associate with "Portfolio"
        },
        {
          title: "Contact",
          icon: "mdi-email", // Replace "mdi-email" with the desired icon for "Contact"
          link: "#contact", // Replace "/contact" with the link you want to associate with "Contact"
        },
      ],
    };
  },
  methods: {
    navigate(link) {
      if (link.includes("#")) {
        if (this.$route.path === "/") {
          this.$vuetify.goTo(link);
        } else {
          this.$router.push("/");
          setTimeout(() => {
            this.$vuetify.goTo(link);
          }, 500); // Delay in milliseconds
        }
        if (this.$vuetify.breakpoint.mobile) {
          this.drawer = !this.drawer;
        }
      } else {
        this.$router.push(link);
      }
    },
  },
};
</script>
